<pt-text-total
  [sum]="sum()"
  [i18nHeader]="i18nHeader()"
  [iconName]="coinIconName"
/>
